import { useState } from 'react'
import { showAlert } from '../services/dialogService'
import TextareaWithCounter from '../components/TextareaWithCounter/TextareaWithCounter'
import './Contact.css'

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    lastname: '',
    phone: '',
    email: '',
    message: ''
  })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    const submitBtn = e.target.querySelector('.btn-submit')
    const originalText = submitBtn.textContent

    try {
      // Crear FormData para enviar a Formspree
      const formDataToSend = new FormData()
      formDataToSend.append('name', formData.name)
      formDataToSend.append('lastname', formData.lastname)
      formDataToSend.append('phone', formData.phone)
      formDataToSend.append('email', formData.email)
      formDataToSend.append('message', formData.message)
      formDataToSend.append('_subject', 'New Contact - The UNFILTERED COLLECTIVE')

      // Enviar a Formspree
      const resp = await fetch('https://formspree.io/f/mlgraevd', {
        method: 'POST',
        body: formDataToSend,
        headers: { 'Accept': 'application/json' }
      })

      if (resp.ok) {
        await showAlert(`Thank you ${formData.name}! We've received your message. We'll get back to you as soon as possible.`)
        // Limpiar formulario
        setFormData({
          name: '',
          lastname: '',
          phone: '',
          email: '',
          message: ''
        })
      } else {
        await showAlert('There was an error submitting the form. Please try again.')
        console.error('Formspree error', resp.status)
      }
    } catch (error) {
      console.error('Network error sending contact form:', error)
      await showAlert('Network error. Please try again in a moment.')
    } finally {
      setIsSubmitting(false)
      if (submitBtn) {
        submitBtn.textContent = originalText
      }
    }
  }

  return (
    <section id="contacto" className="section contacto">
      <h2 className="section-title">CONTACT US</h2>
      <div className="feature-text">
        <p>Have a question or want to get in touch? Fill out the form below and we'll get back to you as soon as possible.</p>
      </div>
      <div className="form-container">
        <form id="contactoForm" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="contacto-name">First Name</label>
            <input
              type="text"
              id="contacto-name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="First Name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="contacto-lastname">Last Name</label>
            <input
              type="text"
              id="contacto-lastname"
              name="lastname"
              value={formData.lastname}
              onChange={handleChange}
              required
              placeholder="Last Name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="contacto-phone">Phone Number</label>
            <input
              type="tel"
              id="contacto-phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="+1 (555) 123-4567"
            />
          </div>
          <div className="form-group">
            <label htmlFor="contacto-email">Email address</label>
            <input
              type="email"
              id="contacto-email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your@email.com"
            />
          </div>
          <div className="form-group">
            <label htmlFor="contacto-message">What would you like to inquire about?</label>
            <TextareaWithCounter
              id="contacto-message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="Tell us about your inquiry..."
              rows={5}
              maxLength={500}
            />
          </div>
          <button type="submit" className="btn-submit" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </section>
  )
}

export default Contact
